import { get_token, get_user_details } from "@/router";
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue";
import StickyNav from "@/components/BottomNavbar/StickyNavbar.vue";
import InactivityModal from "@/components/InactivityTracker/InactivityTracker.vue";
import { homeFilterMethods } from "@/views/organisation/organisation_helpers";
import {
  get_organisation_payfast_data,
  organisationPayfastMethods,
} from "@/views/organisation/organisation_payfast_helper";

export default {
  components: {
    HomeNavBar,
    StickyNav,
    InactivityModal,
  },
  data: () => ({
    token_exists: false,
    user_details: {},
    active_profile: null,
    saved_branding: null,
    company: {},
    ...get_organisation_payfast_data(),
  }),
  computed: {

    organization_company_id() {
      return this.company?.id || this.user_details?.organization_id || null;
    },
    has_payfast_config() {
      return !!this.payfast_config?.id;
    },
  },
  mounted() {
    this.token_exists = !!get_token();
    this.user_details = get_user_details() || {};
    this.saved_branding = this.get_saved_branding();
    this.apply_branding_to_platform(this.saved_branding);

    this.$nextTick(() => {
      this.fetch_company_profile();
      this.fetch_payfast_config();
    });

    window.addEventListener(
      "organization-branding-updated",
      this.handle_organization_branding_updated
    );
  },
  beforeUnmount() {
    window.removeEventListener("organization-branding-updated", this.handle_organization_branding_updated);
  },
  methods: {
    ...homeFilterMethods,
    ...organisationPayfastMethods,
  },
};
